module.exports = __webpack_public_path__ + "static/media/hall-PA.052e7496.svg";